import * as React from 'react'

import { getSiteTermsLink } from '@src/state/site/selectors'
import { RootState } from '@src/state/types'
import { TERMS_LINK } from '@src/utils/dataTestIds'
import { connect } from 'react-redux'
import { TermsAndConditionsContainer } from './styles'

interface StateProps {
  termsLink: string
  className?: string
}

interface OwnProps {
  fontSize?: string
  color?: string
}

export const TERMS_LINK_TEXT = '*See terms and conditions'

export const TermsAndConditions: React.FunctionComponent<StateProps & OwnProps> = ({
  termsLink,
  className,
  fontSize = 'px12',
  color = 'grey',
}) => (
  <TermsAndConditionsContainer
    data-test={TERMS_LINK}
    href={termsLink}
    target="_blank"
    className={className}
    fontSize={fontSize}
    color={color}
  >
    {TERMS_LINK_TEXT}
  </TermsAndConditionsContainer>
)

const mapStateToProps = (state: RootState) => ({
  termsLink: getSiteTermsLink(state),
})

export default connect<StateProps>(mapStateToProps)(TermsAndConditions)



// WEBPACK FOOTER //
// ./src/components/TermsAndConditions/index.tsx